module.exports = __webpack_public_path__ + "img/PerksTopPictureOfferChallenge.ec0061b6.png";